import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { AppointmentService as SharedAppointmentService } from '@avanta/shared/services/appointments';
import { type AppointmentServiceTypes } from './types';

const API_URL = `${BASE_URL}appointments`;

export const AppointmentService: AppointmentServiceTypes = {
  getAppointments: SharedAppointmentService.getAppointments,
  getPsychologistAvailability: async ({
    startDate,
    endDate,
    specialityId,
    centerId,
    psychologistId,
    patientId,
  }) =>
    service.get(`${API_URL}/availability`, {
      params: {
        start: startDate,
        end: endDate,
        patientId,
        specialityId,
        psychologistId,
        centerId,
      },
    }),
  cancel: SharedAppointmentService.cancel,
  sendAppointmentRating: async body =>
    service.post(`${BASE_URL}appointmentSession/any/sessions/patient`, body),
  getSessionDetails: SharedAppointmentService.getSessionDetails,
  getCenterDetails: SharedAppointmentService.getCenterDetails,
  getRecentPsychologists: async patientId =>
    service.get(`${API_URL}/patients/${patientId}/historical`),
  getPsychologistHistoricalPatients: async psychologistId =>
    service.get(`${API_URL}/psychologists/${psychologistId}/historical`),
  editFromPsychologist: async body => service.post(`${API_URL}/change-from-psycho`, body),
  cancelFromPsychologist: async body => service.post(`${API_URL}/cancel-from-psycho`, body),
  getPsychologistNextSessions: async psychologistId =>
    service.get(`${API_URL}/psychologists/${psychologistId}`),
  getAllRecentPatients: async ({ psychologistId, offset, limit, filter, order, nickname }) =>
    service.get(`${BASE_URL}users/recents/patients`, {
      params: {
        psychologist_id: psychologistId,
        offset,
        limit,
        filter,
        order,
        nickname,
      },
    }),
  getCountAllRecentPatients: async ({ psychologistId, offset, limit, nickname }) =>
    service.get(`${BASE_URL}users/recents/patients/count`, {
      params: {
        psychologist_id: psychologistId,
        offset,
        limit,
        nickname,
      },
    }),
};
